import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'luci-mastheads',
  templateUrl: './luci-mastheads.component.html',
  styleUrls: ['./luci-mastheads.component.scss']
})
export class LuciMastheadsComponent implements OnInit {
  @Input() isLight: any;
  @Input() isLogo = false;
  @Input() isNetAppBrandLogo = false;
  @Input() isMenu: '';
  @Input() logoIcon = '';
  @Input() logoTitle = '';
  @Input() isProduct = '';
  @Input() productVersion = '';
  @Input() isSearch = false;
  @Input() productTitle = false;
  @Input() settingsMenu =  [];
  @Input() isSettings = false;
  @Input() isSignIn = false;
  @Input() isManage = false;
  @Input() isLogoImage = '';
  @Input() classList = '';
  @Input() isLogOut = false;
  @Output() updateMenuClick = new EventEmitter();
  @Output() updateSearch  = new EventEmitter();
  @Output() onLogoClick = new EventEmitter();
  @Output() updateSettings = new EventEmitter();
  @Output() signInClick = new EventEmitter();
  @Output() manageClick = new EventEmitter();
  @Output() logOutClick = new EventEmitter();

  isMenuOpen;

  constructor() { }

  ngOnInit(): void {
  }

  getIcon(icon) {
    return `assets/icons/luci.svg#${icon}`;
  }

}
